import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface IEntityOptions {
    entityName: string
}

export const AddFromInventoryDialog: React.SFC<IEntityOptions> = ({ entityName, ...props }: IEntityOptions) => {

    const onCancel = () => {

        setOpen(false);
    }

    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <span>
            <Button variant="outlined" onClick={() => setOpen(true)}>
                Add From Inventory
            </Button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="xs"
            >

                <DialogTitle>
                    Add From Inventory
                </DialogTitle>
                <DialogContent>
                    <Typography>Materials from the inventory that have been added to your basket can be dispatched to this {entityName}.</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancel} color="warning">Cancel</Button>
                    <Button onClick={() => navigate("/basket")}>View Basket</Button>
                </DialogActions>


            </Dialog>
        </span>
    );
}